<template>
  <b-overlay
    id="tour-work-summary"
    :show="processing"
  >
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="3"
          :class="IS_MOBILE() ? 'mb-1' : ''"
        >
          <span>{{ $t('Total time worked') }}</span>
          <h3>
            {{ CONVERT_HM(workSummary.totalDuration) }}
          </h3>
          <p v-if="thisWeekDuration || thisMonthDuration">
            <span>{{ $t("This week") }}:</span>
            <span class="ml-2">{{ CONVERT_HM(thisWeekDuration) }}</span><br>
            <span>{{ $t("This month") }}:</span>
            <span class="ml-2">{{ CONVERT_HM(thisMonthDuration) }}</span><br>
          </p>
        </b-col>
        <b-col
          cols="6"
          md="3"
        >
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <span>{{ $t('Productive time') }}</span>
              <h3>{{ CONVERT_HM(workSummary.productiveDuration) }}</h3>
            </div>
            <div class="text-right mr-2">
              <span>{{ $t('Idle') }}
                <feather-icon
              v-b-tooltip.hover="$t('messages.idle-time-info')"
              icon="InfoIcon"
            />
              </span>
              <h3
                :class="{
                  'text-danger': (workSummary.idlePercent || 0) * 100 > 20,
                  'text-warning': (workSummary.idlePercent || 0) * 100 > 10 && (workSummary.idlePercent || 0) * 100 <= 20
                }"
                :title="`Idle:- ${$t('Approx')} ${CONVERT_HM(Math.round((workSummary.idlePercent || 0) * (workSummary.totalDuration || 0)))}`"
                style="cursor: pointer;"
              >
                {{ workSummary.idlePercent ? Math.round(workSummary.idlePercent * 100) : 0 }}%
              </h3>
            </div>
          </div>
          <br>
          <b-progress
            :max="workSummary.totalDuration"
            style="height: 1rem;"
            class="d-flex"
          >
            <b-progress-bar
              :value="workSummary.productiveDuration * (1 - workSummary.idlePercent)"
              style="background-color: #28c76f;"
              variant="success"
            ></b-progress-bar>
            <b-progress-bar
              :value="workSummary.productiveDuration * workSummary.idlePercent"
              :title="`Idle:- ${$t('Approx')} ${CONVERT_HM(Math.round((workSummary.idlePercent || 0) * (workSummary.totalDuration || 0)))}`"
              class="progress-bar-secondary cursor-pointer bg-secondary"
            ></b-progress-bar>
          </b-progress>
        </b-col>
        <b-col
          cols="6"
          md="2"
          :class="IS_MOBILE() ? 'px-0' : ''"
        >
          <span>{{ $t('Unproductive time') }}
            <feather-icon
              v-b-tooltip.hover="$t('messages.unproductive-time-info')"
              icon="InfoIcon"
            />
          </span>
          <h3>{{ CONVERT_HM(workSummary.unproductiveDuration) }}</h3>
          <br>
          <p>
            <b-progress
              :value="CALC_PERCENTAGE({
                total: workSummary.totalDuration,
                value: workSummary.unproductiveDuration
              })"
              max="100"
              variant="danger"
              class="progress-bar-danger"
            />
          </p>
        </b-col>
        <b-col
          cols="6"
          md="2"
        >
          <span>{{ $t('Neutral time') }}
            <feather-icon
              v-b-tooltip.hover="$t('messages.neutral-time-info')"
              icon="InfoIcon"
            />
          </span>
          <h3>{{ CONVERT_HM(workSummary.neutralDuration) }}</h3>
          <br>
          <p>
            <b-progress
              :value="CALC_PERCENTAGE({
                total: workSummary.totalDuration,
                value: workSummary.neutralDuration
              })"
              max="100"
              variant="secondary"
              class="progress-bar-secondary"
            />
          </p>
        </b-col>
        <b-col
          cols="6"
          md="2"
          :class="IS_MOBILE() ? 'px-0' : ''"
        >
          <span>{{ $t('Manual Time') }} </span>
          <h3>{{ CONVERT_HM(workSummary.manualDuration) }}</h3>
          <br>
          <p>
            <b-progress
              value="0"
              max="100"
              variant="primary"
              class="progress-bar-primary"
            />
          </p>
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>
<script>
import {
  BCard, BProgress, BOverlay, VBTooltip, BProgressBar,
}
from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BProgress,
    BOverlay,
    BProgressBar,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    workSummary: {
      type: Object,
      default: () => {},
    },
    thisWeekDuration: {
      type: Number,
      default: 0,
    },
    thisMonthDuration: {
      type: Number,
      default: 0,
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
